import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";
import SEO from "@/components/SEO";

export default function NotFoundPage() {
  useEffect(() => { document.title = "Page not found · Accommodation Suppliers"; }, []);
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center" data-testid="notfound-page">
      <SEO title="Page not found" description="This page checked out early. Search the directory or head back to the homepage." noindex />
      <div className="tracking-overline mb-4 text-[#B35C4A]">404 · Page not found</div>
      <div
        className="font-serif text-[96px] md:text-[128px] leading-none text-[#264839] mb-2"
        aria-hidden="true"
        style={{ letterSpacing: "-0.04em" }}
      >
        404
      </div>
      <h1 className="font-serif text-3xl md:text-4xl text-[#11211A] tracking-tight mb-4">
        This page checked out early
      </h1>
      <p className="text-[#4A5550] leading-relaxed max-w-md mx-auto">
        The link you followed might be stale, or the listing may have moved. Either way, the directory is a few clicks away.
      </p>
      <div className="mt-10 flex gap-3 justify-center flex-wrap">
        <Link to="/" className="btn-primary inline-flex items-center gap-2" data-testid="notfound-home">
          <Home className="w-4 h-4" /> Back to home
        </Link>
        <Link to="/search" className="btn-secondary inline-flex items-center gap-2" data-testid="notfound-search">
          <Search className="w-4 h-4" /> Search suppliers
        </Link>
      </div>
      <div className="mt-12 pt-6 border-t border-[#E8ECE9] text-xs text-[#7D8C85]">
        Still can't find what you're looking for? <Link to="/contact" className="underline hover:text-[#264839]">Get in touch</Link>.
      </div>
    </div>
  );
}
